//import react from 'react'

const Logo = () => <img alt="Logo" height="50px" src="/cvPlusLogo2.png" />;

export default Logo;
